module.exports = __webpack_public_path__ + "img/38.ee1a9f5d.jpg";